        <version-breadcrumb-header
            [version]="version"
            [title]="bcTitle"
            [breadcrumbs]="breadcrumbs"
            [menu]="menuHeader"
            [bulkEdition]="true"
            (action)="onMenuHeaderClick($event)"
            (setLabels)="onSetGroupLabels($event)"
        ></version-breadcrumb-header>
        <div class="loader" [hidden]="status != STATUS_LOADING">
            <div class="dimmed dimmed_list">
                <div class="dimmed_table_box"></div>
                <div class="dimmed_table_box"></div>
                <div class="dimmed_table_box"></div>
                <div class="dimmed_table_box"></div>
            </div>
        </div>
        <div class="version versions-vrelated"  *ngIf="status == STATUS_DONE">
        <!-- TODO: we need the project for links to plugins, in the case -->
            <ul class="version-related-item">
                <li class="version-related-li" *ngFor="let version of relateds" >
                    <versions-summary-status-box
                        [version]="version"
                        [exclude]="version.labels"
                        [feedbacks]="getFeedbacks(version)"
                        [menu]="menu"
                        (menuClick)="onMenuClick($event)"
                        (actionFileClick)="onFileClick(version,$event)"
                        (menuStatusClick)="updateVersionStatus($event,version)"
                    ></versions-summary-status-box>
                </li>
            </ul>
        </div>

